module.exports = __webpack_public_path__ + "static/img/test.a4a3afe.jpg";